<template>
  <div>
    <bar-chart :chart-data="chartData" :chart-options="options"></bar-chart>
  </div>
</template>

<script>
import BarChart from "../chart/BarChart.vue";

export default {
  components: {
    BarChart
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              barPercentage: 0.3
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    };
  }
};
</script>
